export const selectDisponibilityState = (state) => state.disponibility ?? {
  slotsByDate: {},
  availableSlotsByDate: {},
  allSlots: [],
  loading: false,
  error: null,
  successMessage: null,
};

export const selectDoctorSlotsByDate = (date) => (state) =>
  selectDisponibilityState(state).slotsByDate?.[date] || [];

export const selectDoctorAvailableSlotsByDate = (date) => (state) =>
  selectDisponibilityState(state).availableSlotsByDate?.[date] || [];

export const selectAllDisponibilitySlots = (state) =>
  selectDisponibilityState(state).allSlots || [];

export const selectDisponibilityLoading = (state) =>
  selectDisponibilityState(state).loading;

export const selectDisponibilityError = (state) =>
  selectDisponibilityState(state).error;

export const selectDisponibilitySuccessMessage = (state) =>
  selectDisponibilityState(state).successMessage;